
<template>
    <div class="mt-5">
        <h4>Your recent claims</h4>

        <table class="table mt-5">
            <thead>
                <tr>
                    <th scope="col">Claim Reference</th>
                    <th scope="col">Related Reference</th>
                    <th scope="col">Policy Number</th>
                    <th scope="col">Email</th>
                    <th scope="col">Last Viewed</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(cl, idx) in recentClaimList" :key="'recentClaimList_' + idx">
                    <td><a href="javascript:void(0)" v-on:click="goToClaim(cl.claimId, idx)">{{cl.claimReference}}</a></td>
                    <td>{{cl.relatedReference}}</td>
                    <td>{{cl.policyNumber}}</td>
                    <td>{{cl.email}}</td>
                    <td>{{cl.lastViewed}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";

    export default {
        name: 'Home',
        components: {},
        data: () => {
            return {
            }
        },
        beforeMount() {
            this.clearClaimsList()
        },
        mounted() {
            this.loadRecentClaimList()
        },
        computed: {
            ...mapGetters({
                recentClaimList: 'recentClaimStore/recentClaimList'
            })
        },
        methods: {
            ...mapActions({
                loadRecentClaimList: "recentClaimStore/fetchRecentClaimsList",
                fetchSelectedClaimEx: 'fetchSelectedClaimEx',
                clearClaimsList: 'clearClaimsList',
                clearSelectedClaim: 'clearSelectedClaim',
                setSelectedClaimIndex: 'setSelectedClaimIndex'
            }),
            goToClaim(id, idx) {
                //this.clearClaimsList()
                this.clearSelectedClaim()
                this.setSelectedClaimIndex(idx)
                this.fetchSelectedClaimEx(id)
                this.$router.push('/dashboard/myrecentclaims/approve')
            }
        }
    }
</script>